import { combineEpics } from "redux-observable";
import { invoiceStatusEpic } from "./invoiceStatusEpic";

export const esvEpic = combineEpics(invoiceStatusEpic);
